import { PackagingSystemApiService } from 'src/app/data-transfer/services/packaging-system-api-service';
import { getDialogConfig } from 'src/app/util/dialog-util';
import { AffectedPackagingConfirmation, confirmAffectedPackaging } from 'src/app/util/affected-packaging-util';
import { PpwrDocumentHandlingModeDto } from 'src/app/data-transfer/entities/ppwr-entities/ppwr-document-handling-mode-dto';
import { PackagingPart } from 'src/app/model/packaging-part-enum';
import { PackagingSystemNavigationService } from './../../../../navigation/services/navigation-services/packaging-system-navigation.service';
import { PackagingSystemChildSystem, PackagingSystemChildUnit, PackagingSystemDto } from './../../../../data-transfer/entities/packaging-system-entities/packaging-system-dto';
import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, FormControl } from '@angular/forms';
import { ComponentCanDeactivate } from 'src/app/services/unsaved-changes-guard';
import { AuthService } from 'src/app/services/auth-service';
import { MatDialog } from '@angular/material/dialog';
import { CreateUpdateHandler } from 'src/app/services/packaging-services/create-update-handler';
import { ColorThemeService } from 'src/app/navigation/services/color-theme-service';
import { ActivatedRoute, Router } from '@angular/router';
import { VersionDto } from 'src/app/data-transfer/entities/version-dto';
import { NgxSpinnerService } from 'ngx-spinner';
import { FileApiService } from 'src/app/data-transfer/services/file-api-service';
import {
  CreateUpdatePackagingPartComponent,
  READ_ONLY_SUB_REQUEST_STATUSES_FOR_RECEIVER,
} from 'src/app/components/shared-components/parent-components/create-update-packaging-part/create-update-packaging-part.component';
import { PackagingEntityInHierarchyDto, PackagingSystemUpdateDto } from 'src/app/data-transfer/entities/packaging-system-entities/packaging-system-update-dto';
import { Observable, firstValueFrom, forkJoin } from 'rxjs';
import { SelectionDialogPackagingUnitsComponent } from 'src/app/components/dialogs/selection-dialog-packaging-units/selection-dialog-packaging-units.component';
import { PackagingUnitDto } from 'src/app/data-transfer/entities/packaging-unit-entities/packaging-unit-dto';
import { PackagingUnitApiService } from 'src/app/data-transfer/services/packaging-unit-api-service';
import { DialogActions } from 'src/app/model/dictionary';
import {
  PackagingSystemTreeLevel,
  PackagingUnitTreeLevel,
  TreeLevelParent,
} from 'src/app/components/shared-components/parent-components/packaging-part-tree/packaging-part-tree.component';
import { PackagingComponentTypesEnum } from 'src/app/model/packaging-component-types-enum';
import { CoreDataUpdateService } from 'src/app/data-transfer/services/core-data-update-api-service';
import { SelectionDialogPackagingSystemsComponent } from 'src/app/components/dialogs/selection-dialog-packaging-systems/selection-dialog-packaging-systems.component';
import { DataExchangeRequestApiService } from 'src/app/data-transfer/services/data-exchange-request-api-service';
import { HeaderInfoDialogComponent } from 'src/app/components/dialogs/header-info-dialog/header-info-dialog.component';
import { PathResolveService } from 'src/app/services/path-resolve.service';
import { SimpleAlertDialogComponent } from 'src/app/components/dialogs/simple-alert-dialog/simple-alert-dialog.component';
import { PackagingUnitNavigationService } from 'src/app/navigation/services/navigation-services/packaging-unit-navigation.service';
import { DirectoryApiService } from 'src/app/data-transfer/services/directory-api-service';
import { TranslocoService } from '@jsverse/transloco';
import { openCreateDataExchangeRequestDialog } from 'src/app/util/data-exchange-request-util';
import { DataExchangeSubRequestInfoDto } from 'src/app/data-transfer/entities/data-exchange-request-entities/data-exchange-sub-request-info-dto';
import { DataExchangeRequestDto } from 'src/app/data-transfer/entities/data-exchange-request-entities/data-exchange-request-dto';
import { DataExchangeRequestStatusDto } from 'src/app/data-transfer/entities/data-exchange-request-entities/data-exchange-request-status-dto';
import { UpdateDataExchangeRequestStatusDto } from 'src/app/data-transfer/entities/data-exchange-request-entities/update-data-exchange-request-status-dto';
import {
  SubRequestCommentsDialogComponent,
  SubRequestCommentsDialogData,
  SubRequestCommentsDialogResult,
} from 'src/app/components/dialogs/sub-request-comments-dialog/sub-request-comments-dialog.component';
import { PpwrDocumentsComponent } from 'src/app/components/shared-components/ppwr-documents/ppwr-documents.component';
import { PpwrApiService } from 'src/app/data-transfer/services/ppwr-api.service';

@Component({
  selector: 'app-create-update-packaging-system',
  templateUrl: './create-update-packaging-system.component.html',
  styleUrls: ['./create-update-packaging-system.component.scss'],
})
export class CreateUpdatePackagingSystemComponent extends CreateUpdatePackagingPartComponent implements OnInit, ComponentCanDeactivate {

  @ViewChild(PpwrDocumentsComponent) private ppwrDocumentsComponent!: PpwrDocumentsComponent;

  packagingSystemForm!: FormGroup;
  packagingSystem!: PackagingSystemDto;
  selectedSystemNode: PackagingSystemTreeLevel | null = null;
  selectedUnitNode: PackagingUnitTreeLevel | null = null;
  currentHierarchyFormGroup!: FormGroup;
  formSubmitted = false;
  componentTypes = PackagingComponentTypesEnum;
  private packagingSystemChildrenUpdated = false;

  isDataExchangeSubRequest = false;
  subRequestInfo: DataExchangeSubRequestInfoDto | null = null;
  isInOngoingDataExchange: DataExchangeRequestDto[] = [];
  readonly dataExchangeRequestsPath = '/' + PathResolveService.getDataExchangeRequestsPath(true);
  readonly DataExchangeRequestStatusDto = DataExchangeRequestStatusDto;

  get currentHierarchyFormGroupQuantityControl(): FormControl {
    return this.currentHierarchyFormGroup.controls.quantity as FormControl;
  }

  get currentHierarchyFormGroupCurrentUnitControl(): FormControl {
    return this.currentHierarchyFormGroup.controls.currentUnit as FormControl;
  }

  get currentHierarchyFormGroupCurrentSystemControl(): FormControl {
    return this.currentHierarchyFormGroup.controls.currentSystem as FormControl;
  }

  get packagingSystemFieldsControl(): FormControl {
    return this.packagingSystemForm.controls.packagingSystemFields as FormControl;
  }

  constructor(
    protected createUpdateHandler: CreateUpdateHandler,
    protected dialog: MatDialog,
    protected cdr: ChangeDetectorRef,
    protected colorThemeService: ColorThemeService,
    protected authService: AuthService,
    protected spinner: NgxSpinnerService,
    protected route: ActivatedRoute,
    protected fileApiService: FileApiService,
    protected coreDataUpdateService: CoreDataUpdateService,
    private psApiService: PackagingSystemApiService,
    private puApiService: PackagingUnitApiService,
    private formBuilder: FormBuilder,
    private navigationService: PackagingSystemNavigationService,
    private unitNavigationService: PackagingUnitNavigationService,
    private router: Router,
    private dataExchangeApiService: DataExchangeRequestApiService,
    private directoryApiService: DirectoryApiService,
    private translocoService: TranslocoService,
    private ppwrApiService: PpwrApiService
  ) {
    super(createUpdateHandler, dialog, colorThemeService, authService, cdr, route, spinner, fileApiService, coreDataUpdateService);
  }

  ngOnInit(): void {
    this.routeDataSubscription = this.route.data.subscribe(data => {
      if (data.packagingSystem) {
        this.packagingSystem = data.packagingSystem;
      }
    });

    this.routeParamsSubscription = this.route.params.subscribe(params => {
      if (params.candidateId) {
        this.isPreview = true;
      }
    });
    this.routeDataSubscription = this.route.data.subscribe(data => {
      if (data.packagingSystem) {
        if (this.packagingSystemForm) {
          window.location.reload();
          this.initPackaging();
        }
        this.packagingSystem = data.packagingSystem;
        this.relevantAnalysisTypes.ccRelevant = data.packagingSystem.isCCRelevant;
        this.relevantAnalysisTypes.lcaRelevant = data.packagingSystem.isLCARelevant;
        this.relevantAnalysisTypes.ppwrRelevant = data.packagingSystem.isPPWRRelevant;
        this.relevantAnalysisTypes.recyclingRelevant = data.packagingSystem.isRecyclabilityRelevant;
        this.currentDirectoryId = data.packagingSystem.directoryId;
        this.selectedTags = this.allTags.filter(tag => this.packagingSystem.associatedTagIdentifiers?.includes(tag.id ?? -1) ?? false);
      } else if (data.dataExchangeRequest) {
        if (this.packagingSystemForm) {
          window.location.reload();
          this.initPackaging();
        }
        this.packagingSystem = data.dataExchangeRequest.packagingSystem;
        this.subRequestInfo = data.dataExchangeRequest.subRequestInfo;
        this.relevantAnalysisTypes.ccRelevant = data.dataExchangeRequest.packagingSystem.isCCRelevant;
        this.relevantAnalysisTypes.lcaRelevant = data.dataExchangeRequest.packagingSystem.isLCARelevant;
        this.relevantAnalysisTypes.ppwrRelevant = data.dataExchangeRequest.packagingSystem.isPPWRRelevant;
        this.relevantAnalysisTypes.recyclingRelevant = data.dataExchangeRequest.packagingSystem.isRecyclabilityRelevant;
        this.currentDirectoryId = data.dataExchangeRequest.packagingSystem.directoryId;
        this.selectedTags = this.allTags.filter(tag => this.packagingSystem.associatedTagIdentifiers?.includes(tag.id ?? -1) ?? false);
      } else {
        this.packagingSystem = new PackagingSystemDto();
      }
      if (data.permissions) {
        this.permissions = data.permissions;
        this.isEditPermitted = this.permissions?.write ?? true;
      }
      if (data.isDataExchangeSubRequest) {
        this.isDataExchangeSubRequest = true;
        if (!data.permissions) {
          this.psApiService.getPackagingSystemPermissions(this.packagingSystem.id ?? -1).subscribe(permissions => {
            this.permissions = permissions;
            if (this.subRequestInfo?.isReceiver && READ_ONLY_SUB_REQUEST_STATUSES_FOR_RECEIVER.includes(this.subRequestInfo?.subRequest?.status ?? -1)) {
              this.isEditPermitted = false;
            } else {
              this.isEditPermitted = this.permissions?.write ?? true;
            }
            this.disableFormIfRequired(this.packagingSystemForm);
          });
        }
      }
      if (data.isInOngoingDataExchange) {
        this.isInOngoingDataExchange = data.isInOngoingDataExchange;
        if (this.isInOngoingDataExchange.length > 0 && this.packagingSystem.isCurrentVersion) {
          const firstRequest = this.isInOngoingDataExchange[0];
          const subRequest = firstRequest.subRequests?.find(sr => sr.packagingSystemInfo?.id === this.packagingSystem.id);
          const path = subRequest ? '/' + PathResolveService.getDataExchangeRequestPackagingSystemPath(true, subRequest.id) : this.dataExchangeRequestsPath;
          this.router.navigateByUrl(path);
          return;
        }
      }

      this.packagingSystemForm = this.formBuilder.group({
        packagingSystemFields: this.formBuilder.control(this.packagingSystem),
        hierarchy: this.formBuilder.group({
          id: this.packagingSystem.id,
          currentSystem: this.packagingSystem,
          childSystems: this.formBuilder.array([]),
          childUnits: this.formBuilder.array([]),
        }),
        newVersionName: [''],
      });
      this.packagingSystemForm.controls.hierarchy = this.createFormRecursively(this.packagingSystem, this.packagingSystemForm.controls.hierarchy as FormGroup);
      this.currentHierarchyFormGroup = this.getCurrentHierarchyLevelFormGroup();
      this.initPackaging();
    });
  }

  openHeaderInfoUnit(element: any, event: MouseEvent) {
    event.stopPropagation();
    const unit = this.findUnitRecursively(element.value.id, this.packagingSystem);

    const dialogData = {
      headerInfoData: unit.underlyingPackagingUnit,
    };
    this.dialog.open(HeaderInfoDialogComponent, getDialogConfig(dialogData, '1200px'));
  }

  openHeaderInfoSystem(element: any, event: MouseEvent) {
    event.stopPropagation();
    const system = this.findSystemRecursively(element.value.id, this.packagingSystem);

    const dialogData = {
      headerInfoData: system.underlyingPackagingSystem,
    };
    this.dialog.open(HeaderInfoDialogComponent, getDialogConfig(dialogData, '1200px'));
  }

  private createFormRecursively(packagingSystem: PackagingSystemDto, hierarchyNode: FormGroup) {
    hierarchyNode.controls.childSystems = this.formBuilder.array([]);
    packagingSystem.packagingSystems.forEach(child => {
      const childSystems = this.formBuilder.array([]);
      const control = this.formBuilder.group({
        id: child.underlyingPackagingSystem.id,
        version: child.underlyingPackagingSystem.version,
        index: child.index,
        quantity: new FormControl(child.quantity, { updateOn: 'blur' }),
        currentSystem: child.underlyingPackagingSystem,
        childSystems,
      });
      control.controls.currentSystem.disable();
      (hierarchyNode.controls.childSystems as FormArray).push(control);
      this.addPackagingUnitsToLevel(child.underlyingPackagingSystem, hierarchyNode);
      this.createFormRecursively(child.underlyingPackagingSystem, control);
    });
    this.addPackagingUnitsToLevel(packagingSystem, hierarchyNode);
    return hierarchyNode;
  }

  private addPackagingUnitsToLevel(packagingSystem: PackagingSystemDto, hierarchyNode: FormGroup) {
    hierarchyNode.controls.childUnits = this.formBuilder.array([]);
    packagingSystem.packagingUnits.forEach(child => {
      const packagingUnit = child.underlyingPackagingUnit;
      const unitControl: FormGroup = this.formBuilder.group({
        id: packagingUnit.id,
        version: packagingUnit.version,
        index: child.index,
        quantity: new FormControl(child.quantity, { updateOn: 'blur' }),
        currentUnit: packagingUnit,
      });
      if (packagingUnit.mainBody) {
        unitControl.addControl('mainBody', this.formBuilder.control([packagingUnit.mainBody]));
      }
      if (packagingUnit.closures.length > 0) {
        unitControl.addControl('closures', this.formBuilder.control(packagingUnit.closures));
      }
      if (packagingUnit.sleeves.length > 0 || packagingUnit.labels.length > 0 || packagingUnit.inMoldLabels.length > 0) {
        unitControl.addControl('decorations', this.formBuilder.control(packagingUnit.sleeves.concat(packagingUnit.labels).concat(packagingUnit.inMoldLabels)));
      }
      if (packagingUnit.inlays.length > 0) {
        unitControl.addControl('inlays', this.formBuilder.control(packagingUnit.inlays));
      }
      if (packagingUnit.packagingAids.length > 0) {
        unitControl.addControl('packagingAids', this.formBuilder.control(packagingUnit.packagingAids));
      }
      unitControl.controls.currentUnit.disable();
      (hierarchyNode.controls.childUnits as FormArray).push(unitControl);
    });
  }

  @HostListener('window:beforeunload')
  canDeactivate(): boolean {
    return (this.packagingSystemForm?.pristine && !this.filesEdited)
      || this.isPreview || this.isUserValidator || this.isUserAdmin || this.isHistory;
  }

  async releaseComponent() {
    const releaseFunction = (packagingSystemId: number) => this.psApiService.releasePackagingSystem(packagingSystemId, true);
    super.releaseComponent(this.packagingSystem.id, releaseFunction);
  }

  private initPackaging() {
    this.isHistory = this.packagingSystem.id != null && !this.packagingSystem.isCurrentVersion;
    this.isTracked = this.packagingSystem.hasExternalTracking ?? false;
    const lockFunction = (packagingSystemId: number) => this.psApiService.lockPackagingSystem(packagingSystemId, true);
    this.setUpLockAndHeartbeat(this.packagingSystemForm, lockFunction, this.packagingSystem?.id);
    super.disableFormIfRequired(this.packagingSystemForm);
    this.historyVersions = [
      {
        id: this.packagingSystem.id,
        versionNumber: this.packagingSystem.version,
        versionName: this.packagingSystem.versionName,
        creationTimestamp: this.packagingSystem.creationTimestamp,
        isCurrentVersion: this.packagingSystem.isCurrentVersion,
      },
    ];
  }

  loadHistoryVersions() {
    const versionsFunction = (packagingSystemId: number) => this.psApiService.getPackagingSystemHistoryVersions(packagingSystemId);
    super.loadHistoryVersions(this.packagingSystem.id, versionsFunction);
  }

  onHistoryVersionChange(version: number) {
    const navigationFunction = (packagingSystemId: number, packagingSystemVersion?: number) => {
      if (packagingSystemVersion == null && this.isInOngoingDataExchange.length > 0) {
        const firstRequest = this.isInOngoingDataExchange[0];
        const subRequest = firstRequest.subRequests?.find(sr => sr.packagingSystemInfo?.id === packagingSystemId);
        const path = subRequest ? '/' + PathResolveService.getDataExchangeRequestPackagingSystemPath(true, subRequest.id) : this.dataExchangeRequestsPath;
        this.router.navigateByUrl(path);
      } else {
        this.navigationService.navigateToPackagingSystem(packagingSystemId, packagingSystemVersion);
      }
    };
    super.onHistoryVersionChange(version, navigationFunction);
  }

  editVersionName(packagingSystem: VersionDto) {
    const renameFunction = (id: number, version: number, name: string) => this.psApiService.renamePackagingSystem(id, version, name, true);
    super.editVersionName(packagingSystem, this.packagingSystem, renameFunction);
  }

  onNodeSelected(node: TreeLevelParent | null) {
    this.selectedSystemNode = null;
    this.selectedUnitNode = null;
    if (!node) {
      return;
    }
    if (node.type === PackagingPart.System) {
      this.selectedSystemNode = node;
    } else if (node.type === PackagingPart.Unit) {
      this.selectedUnitNode = node;
    }
    this.currentHierarchyFormGroup = this.getCurrentHierarchyLevelFormGroup();
  }

  private getCurrentHierarchyLevelFormGroup(): FormGroup {
    const hierarchyRoot = this.packagingSystemForm.controls.hierarchy as FormGroup;
    let returnNode: FormGroup = this.formBuilder.group({});
    if (this.selectedSystemNode) {
      const id = this.selectedSystemNode?.id;
      returnNode = this.findSystemControlRecursively(id, hierarchyRoot);
      this.quantityChangesSubscription = returnNode.controls.quantity.valueChanges.subscribe((newQuantity: number) => {
        const ps = this.findSystemRecursively(id, this.packagingSystem);
        if (!ps) {
          return;
        }
        ps.quantity = newQuantity;
        this.setDisplayedData();
      });
    } else if (this.selectedUnitNode) {
      const id = this.selectedUnitNode?.id;
      returnNode = this.findUnitControlRecursively(id, hierarchyRoot);
      this.quantityChangesSubscription = returnNode.controls.quantity.valueChanges.subscribe((newQuantity: number) => {
        const pu = this.findUnitRecursively(id, this.packagingSystem);
        if (!pu) {
          return;
        }
        pu.quantity = newQuantity;
        this.packagingSystem = { ...this.packagingSystem }; // called to update the tree view
        this.setDisplayedData();
      });
    }
    return returnNode;
  }

  private findSystemRecursively(packagingSystemId: number, packagingSystem: PackagingSystemDto): any {
    let returnPackagingSystem: PackagingSystemChildSystem | null = null;
    if (packagingSystemId === packagingSystem.id) {
      return packagingSystem;
    }
    const childSystems = packagingSystem.packagingSystems;
    for (const childSystem of childSystems) {
      if (packagingSystemId === childSystem.underlyingPackagingSystem.id) {
        returnPackagingSystem = childSystem;
      } else {
        returnPackagingSystem = this.findSystemRecursively(packagingSystemId, childSystem.underlyingPackagingSystem);
      }
      if (returnPackagingSystem != null) {
        return returnPackagingSystem;
      }
    }
  }

  private findUnitRecursively(packagingUnitId: number, packagingSystem: PackagingSystemDto): any {
    let returnPackagingUnit: PackagingSystemChildUnit | null = null;
    const unit = packagingSystem.packagingUnits.find(x => x.underlyingPackagingUnit.id === packagingUnitId);
    if (unit) {
      return unit;
    }
    const childSystems = packagingSystem.packagingSystems;
    for (const childSystem of childSystems) {
      const unit = packagingSystem.packagingUnits.find(x => x.underlyingPackagingUnit.id === packagingUnitId);
      if (unit) {
        returnPackagingUnit = unit;
      } else {
        returnPackagingUnit = this.findUnitRecursively(packagingUnitId, childSystem.underlyingPackagingSystem);
      }
      if (returnPackagingUnit != null) {
        return returnPackagingUnit;
      }
    }
  }

  private findSystemControlRecursively(nodeId: number, formGroup: FormGroup): FormGroup {
    let returnControl = null;
    if (nodeId === formGroup.value.id) {
      return formGroup;
    }
    const childSystems = formGroup.controls.childSystems as FormArray;
    for (const childSystem of childSystems.controls) {
      if (nodeId === childSystem.value.id) {
        returnControl = childSystem;
      } else {
        returnControl = this.findSystemControlRecursively(nodeId, childSystem as FormGroup);
      }
      if (returnControl != null) {
        return returnControl as FormGroup;
      }
    }
    return this.formBuilder.group({});
  }

  private findUnitControlRecursively(nodeId: number, formGroup: FormGroup): any {
    let returnControl = null;
    const unit = this.findChildUnitInFormById(nodeId, formGroup);
    if (unit) {
      return unit;
    }
    const childSystems = formGroup.controls.childSystems as FormArray;
    for (const childSystem of childSystems.controls) {
      const unit = this.findChildUnitInFormById(nodeId, childSystem as FormGroup);
      if (unit) {
        returnControl = unit;
      } else {
        returnControl = this.findUnitControlRecursively(nodeId, childSystem as FormGroup);
      }
      if (returnControl != null) {
        return returnControl;
      }
    }
  }

  private findChildUnitInFormById(nodeId: number, formGroup: FormGroup): FormGroup | null {
    const unit = (formGroup.controls.childUnits as FormArray).controls.find(x => x.value.id === nodeId) as FormGroup;
    return unit ?? null;
  }

  async importPackagingSystem() {
    this.spinner.show();
    const displayedColumns = ['id', 'brandName', 'productName', 'articleNumber', 'select'];

    const dialogConfig = getDialogConfig({ displayedColumns }, '1100px');
    const dialogRef = this.dialog.open(SelectionDialogPackagingSystemsComponent, dialogConfig);
    this.spinner.hide();
    this.dialogSubscription = dialogRef.afterClosed().subscribe(async result => {
      if (result.event === DialogActions.REJECT) {
        return;
      }
      const observables: Observable<any>[] = result.selectedPackagingSystemIds.map((packagingSystemId: number) => {
        if (packagingSystemId != null) {
          return this.psApiService.getPackagingSystem(packagingSystemId);
        }
      });

      if (observables.length === 0) {
        this.setDisplayedData();
        return;
      }

      const completePackagingSystems = await firstValueFrom(forkJoin(observables));
      let lastIndex = this.packagingSystem.packagingSystems.length + this.packagingSystem.packagingUnits.length - 1;
      const childPackagingSystems: PackagingSystemChildSystem[] = completePackagingSystems.map(ps => ({
        index: ++lastIndex,
        quantity: 1,
        underlyingPackagingSystem: ps,
      }));
      this.packagingSystem = {
        ...this.packagingSystem,
        packagingSystems: this.packagingSystem.packagingSystems.concat(childPackagingSystems),
      };
      this.setDisplayedData();
    });
  }

  async importPackagingUnit() {
    this.spinner.show();

    const displayedColumns = ['id', 'packagingTypeName', 'brandName', 'productName', 'articleNumber', 'select'];

    const dialogConfig = getDialogConfig({ displayedColumns }, '1100px');
    const dialogRef = this.dialog.open(SelectionDialogPackagingUnitsComponent, dialogConfig);
    this.spinner.hide();
    this.dialogSubscription = dialogRef.afterClosed().subscribe(async result => {
      if (result.event === DialogActions.REJECT) {
        return;
      }
      const observables: Observable<any>[] = result.selectedPackagingUnitIds.map((packagingUnitId: number) => {
        if (packagingUnitId != null) {
          return this.puApiService.getPackagingUnit(packagingUnitId);
        }
      });

      if (observables.length === 0) {
        this.setDisplayedData();
        return;
      }

      const completePackagingUnits: PackagingUnitDto[] = await firstValueFrom(forkJoin(observables));
      let lastIndex = this.packagingSystem.packagingSystems.length + this.packagingSystem.packagingUnits.length - 1;
      const childPackagingUnits: PackagingSystemChildUnit[] = completePackagingUnits.map(pu => ({
        index: ++lastIndex,
        quantity: 1,
        underlyingPackagingUnit: pu,
      }));
      this.packagingSystem = {
        ...this.packagingSystem,
        packagingUnits: this.packagingSystem.packagingUnits.concat(childPackagingUnits),
      };
      this.setDisplayedData();
    });
  }

  private setDisplayedData() {
    this.packagingSystemForm.controls.hierarchy = this.createFormRecursively(this.packagingSystem, this.packagingSystemForm.controls.hierarchy as FormGroup);
    this.packagingSystemForm.controls.hierarchy.updateValueAndValidity();
    this.packagingSystemChildrenUpdated = true;
  }

  setTags() {
    this.packagingSystem.associatedTagIdentifiers = this.selectedTags.map(tag => tag.id ?? -1);
  }

  isTopLevelNode(): boolean {
    if (this.selectedSystemNode) {
      return this.packagingSystem.packagingSystems.find(x => x.underlyingPackagingSystem.id === this.selectedSystemNode?.id) != null;
    } else if (this.selectedUnitNode) {
      return this.packagingSystem.packagingUnits.find(x => x.underlyingPackagingUnit.id === this.selectedUnitNode?.id) != null;
    }
    return false;
  }

  deleteNode(): void {
    if (!this.selectedSystemNode && !this.selectedUnitNode) {
      return;
    }
    let deletedIndex: number;
    if (this.selectedSystemNode) {
      this.packagingSystem = {
        ...this.packagingSystem,
        packagingSystems: this.packagingSystem.packagingSystems.filter(x => x.underlyingPackagingSystem.id !== this.selectedSystemNode?.id),
      };
      deletedIndex = this.selectedSystemNode.index;
      this.selectedSystemNode = null;
    } else if (this.selectedUnitNode) {
      this.packagingSystem = {
        ...this.packagingSystem,
        packagingUnits: this.packagingSystem.packagingUnits.filter(x => x.underlyingPackagingUnit.id !== this.selectedUnitNode?.id),
      };
      deletedIndex = this.selectedUnitNode.index;
      this.selectedUnitNode = null;
    }
    this.packagingSystem.packagingSystems.forEach(ps => {
      if (ps.index > deletedIndex) {
        ps.index = ps.index - 1;
      }
    });
    this.packagingSystem.packagingUnits.forEach(pu => {
      if (pu.index > deletedIndex) {
        pu.index = pu.index - 1;
      }
    });
    this.setDisplayedData();
  }

  navigateToNode(): void {
    if (!this.selectedSystemNode && !this.selectedUnitNode) {
      return;
    }
    if (this.selectedSystemNode) {
      this.navigationService.navigateToPackagingSystem(this.selectedSystemNode.id, this.selectedSystemNode.version);
    } else if (this.selectedUnitNode) {
      this.unitNavigationService.navigateToPackagingUnit(this.selectedUnitNode.id, this.selectedUnitNode.version);
    }
  }

  async onSubmit() {
    this.formSubmitted = true;
    if (this.packagingSystemForm.invalid) {
      super.openFormInvalidDialog();
    } else {
      const dirId = this.currentDirectoryId != null ? this.currentDirectoryId : await super.selectDirectory();
      if (dirId == null) {
        return;
      }
      this.addNewPackagingSystem(dirId);
    }
  }

  private isSavePermittedByAffectedPackaging(packagingSystemToSave?: PackagingSystemUpdateDto): Promise<AffectedPackagingConfirmation> {
    return confirmAffectedPackaging(this.dialog, this.translocoService, this.packagingSystem.id,
      (id, stayOnPage) => this.psApiService.getAffectedPackaging(id, stayOnPage), !this.isDataExchangeSubRequest,
      packagingSystemToSave
        ? stayOnPage => this.psApiService.wouldCreateNewVersion(packagingSystemToSave as unknown as PackagingSystemDto, stayOnPage)
        : undefined);
  }

  onSubRequestCommentAdded(text: string): void {
    if (!this.subRequestInfo) {
      return;
    }
    const subRequestId = this.subRequestInfo.subRequest.id;
    this.dataExchangeApiService.addSubRequestComment(subRequestId, text).subscribe({
      next: () => {
        this.dataExchangeApiService.getSubRequestInfo(subRequestId, true).subscribe({
          next: info => {
            this.subRequestInfo = info;
          },
        });
      },
    });
  }

  async onFinishRequest() {
    this.formSubmitted = true;
    if (this.packagingSystemForm.invalid) {
      super.openFormInvalidDialog();
      return;
    }
    const subRequestId = +this.route.snapshot.params['id'];
    const dto = await this.buildPackagingSystemDto();

    const confirmation = await this.isSavePermittedByAffectedPackaging(dto);
    if (!confirmation.proceed) { return; }
    dto.ppwrDocumentHandling = confirmation.handling ?? null;
    const recreateRequested = confirmation.handling?.mode === PpwrDocumentHandlingModeDto.Recreate;
    this.spinner.show();
    this.dataExchangeApiService.updateSubRequestPackagingSystem(subRequestId, dto as unknown as PackagingSystemDto, true, true).subscribe({
      next: _ => {
        this.spinner.hide();
        Object.keys(this.packagingSystemForm.controls).forEach(control => {
          this.packagingSystemForm.controls[control].markAsPristine();
        });
        this.packagingSystemForm.markAsPristine();
        this.filesEdited = false;
        this.router.navigateByUrl('/' + PathResolveService.getDataExchangeRequestsPath(true) + '?tab=1');
      },
      error: e => {
        this.spinner.hide();
        const dialogData = this.createUpdateHandler.getFailureDialogData(e, recreateRequested);
        this.dialog.open(SimpleAlertDialogComponent, getDialogConfig(dialogData, '400px'));
      },
    });
  }

  onApproveSubRequest(): void {
    if (!this.subRequestInfo) {
      return;
    }
    const dto: UpdateDataExchangeRequestStatusDto = { status: DataExchangeRequestStatusDto.Closed };
    this.dataExchangeApiService.updateSubRequestStatus(this.subRequestInfo.subRequest.id, dto, true).subscribe({
      next: () => this.router.navigateByUrl('/' + PathResolveService.getDataExchangeRequestsPath(true)),
    });
  }

  onReopenSubRequest(): void {
    if (!this.subRequestInfo) {
      return;
    }
    const title = this.translocoService.translate('dataManagement.dataExchangeRequests.comments.subRequestTitle');
    const data: SubRequestCommentsDialogData = {
      comments: this.subRequestInfo.subRequest.comments,
      title,
      allowOptionalComment: true,
      confirmButtonTranslationKey: 'dataManagement.dataExchangeRequests.buttons.reopenSubRequest',
    };
    const dialogRef = this.dialog.open(SubRequestCommentsDialogComponent, getDialogConfig(data, '500px'));
    dialogRef.afterClosed().subscribe((result: SubRequestCommentsDialogResult | undefined) => {
      if (!result?.confirmed) {
        return;
      }

      const dto: UpdateDataExchangeRequestStatusDto = { status: DataExchangeRequestStatusDto.ReOpened };
      this.dataExchangeApiService.updateSubRequestStatus(this.subRequestInfo!.subRequest.id, dto, true).subscribe({
        next: () => {
          if (result.comment) {
            this.dataExchangeApiService.addSubRequestComment(this.subRequestInfo!.subRequest.id, result.comment, true).subscribe({
              next: () => this.router.navigateByUrl('/' + PathResolveService.getDataExchangeRequestsPath(true)),
            });
            return;
          }

          this.router.navigateByUrl('/' + PathResolveService.getDataExchangeRequestsPath(true));
        },
      });
    });
  }

  createDataExchangeRequest(): void {
    const packagingSystemId = this.packagingSystem.id;
    if (packagingSystemId == null) {
      return;
    }
    openCreateDataExchangeRequestDialog(
      { dialog: this.dialog, directoryApiService: this.directoryApiService, dataExchangeApiService: this.dataExchangeApiService, translocoService: this.translocoService, destroyRef: this.destroyRef },
      { packagingSystemIds: [packagingSystemId] },
      this.isCreatingDataExchangeRequest,
    );
  }

  get packagingSystemHirarchy() {
    return this.packagingSystemForm.controls.hierarchy as FormGroup;
  }

  private async buildPackagingSystemDto(directoryId?: number): Promise<PackagingSystemUpdateDto> {
    const createUpdatePackagingSystem = new PackagingSystemUpdateDto();
    const formFields = this.packagingSystemForm.value.packagingSystemFields;
    createUpdatePackagingSystem.id = this.packagingSystem.id;
    createUpdatePackagingSystem.docArea = this.packagingSystem.docArea;
    createUpdatePackagingSystem.directoryId = directoryId ?? this.packagingSystem.directoryId;
    createUpdatePackagingSystem.comment = formFields.comment;
    createUpdatePackagingSystem.brandName = formFields.brandName;
    createUpdatePackagingSystem.productName = formFields.productName;
    createUpdatePackagingSystem.articleNumber = formFields.articleNumber;
    createUpdatePackagingSystem.gtin = formFields.gtin;
    createUpdatePackagingSystem.distributionCountries = formFields.distributionCountries;
    createUpdatePackagingSystem.assemblyCountry = formFields.assemblyCountry;
    createUpdatePackagingSystem.customFields = formFields.customFields;

    createUpdatePackagingSystem.length = formFields.length;
    createUpdatePackagingSystem.width = formFields.width;
    createUpdatePackagingSystem.height = formFields.height;

    await super.updateImagesAndDocuments(this.packagingSystem);

    const ppwrFormData = this.ppwrDocumentsComponent.getNewPpwrFilesFormData();
    if (ppwrFormData.has('files')) {
      const ppwrIds = await firstValueFrom(this.fileApiService.putDocuments(ppwrFormData));
      this.ppwrDocumentsComponent.updateDocumentIdsAfterSaving(ppwrIds);
    }
    createUpdatePackagingSystem.ppwrDocuments = this.ppwrDocumentsComponent.documents;

    createUpdatePackagingSystem.images = this.packagingSystem.images;
    createUpdatePackagingSystem.certificates = this.packagingSystem.certificates;
    createUpdatePackagingSystem.documents = this.packagingSystem.documents;
    createUpdatePackagingSystem.docArea = this.packagingSystem.docArea;

    createUpdatePackagingSystem.supplier = formFields.supplier?.trim() ?? null;

    createUpdatePackagingSystem.versionName = this.packagingSystemForm.value?.newVersionName ?? null;
    createUpdatePackagingSystem.associatedTagIdentifiers = this.packagingSystem.associatedTagIdentifiers;

    const hierarchyChildSystems = this.packagingSystemHirarchy.controls.childSystems.value;
    createUpdatePackagingSystem.packagingSystems = this.getChildObjectsFromForm(hierarchyChildSystems);

    const hierarchyChildUnits = this.packagingSystemHirarchy.controls.childUnits.value;
    createUpdatePackagingSystem.packagingUnits = this.getChildObjectsFromForm(hierarchyChildUnits);

    return createUpdatePackagingSystem;
  }

  private async addNewPackagingSystem(directoryId: number) {
    const createUpdatePackagingSystem = await this.buildPackagingSystemDto(directoryId);

    const confirmation = await this.isSavePermittedByAffectedPackaging(createUpdatePackagingSystem);
    if (!confirmation.proceed) { return; }
    createUpdatePackagingSystem.ppwrDocumentHandling = confirmation.handling ?? null;

    let saveFunction = (packagingItem: PackagingSystemDto, stayOnPage: boolean) =>
      this.psApiService.putPackagingSystem(packagingItem, stayOnPage);

    let navFunction = (id: number, version: number) => this.navigationService.navigateToPackagingSystem(id, version);

    if (this.isDataExchangeSubRequest) {
      const subRequestId = +this.route.snapshot.params['id'];
      saveFunction = (packagingItem: PackagingSystemDto, stayOnPage: boolean) =>
        this.dataExchangeApiService.updateSubRequestPackagingSystem(subRequestId, packagingItem, undefined, stayOnPage);
      navFunction = (id: number, version: number) => {
        const path = PathResolveService.getDataExchangeRequestPackagingSystemPath(true, this.route.snapshot.params['id']);
        this.router.navigateByUrl(path);
      };
    }

    const removedPpwrDocumentIds = this.ppwrDocumentsComponent.getRemovedDocumentIds();
    const afterSaveFunction = removedPpwrDocumentIds.length > 0
      ? (id: number) => this.ppwrApiService.deletePpwrDocumentsForSystem(id, removedPpwrDocumentIds)
      : undefined;

    super.putPackagingItem(createUpdatePackagingSystem, this.packagingSystemForm, saveFunction, navFunction, afterSaveFunction);
  }

  private getChildObjectsFromForm(packagingItems: any[]): PackagingEntityInHierarchyDto[] {
    return packagingItems.map(packagingItem => ({
      id: packagingItem.id,
      version: packagingItem.version,
      index: packagingItem.index,
      quantity: packagingItem.quantity,
    }));
  }
}
